export default __webpack_public_path__ + "static/media/PLISANCI-01_selected.331fe8d7.svg";